import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Search from 'react-search'
import Suggest from 'react-autosuggest'
import axios from 'axios';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { setKeyword, requestSuggest, clearSuggests } from './actions';
import API_URL from './../../constants/server';
import CampaignWrapper from './style';

class AddCampaign extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      repos: [],
      campaignList: [

        {"id":36110145,"orgId":379480,"name":"kawa US","budgetAmount":{"amount":"10","currency":"USD"},
        "dailyBudgetAmount":{"amount":"1","currency":"USD"},"adamId":1025397186,"referenceLabel":null,
        "negativeKeywords":[],"paymentModel":"PAYG","locInvoiceDetails":null,
        "adGroups":[{"id":36061494,"campaignId":36110145,"name":"Trial 1","cpaGoal":{"amount":"0.5","currency":"USD"},
        "storefronts":["US"],"startTime":"2017-09-22T16:00:00.000","endTime":null,"automatedKeywordsOptIn":true,
        "defaultCpcBid":{"amount":"0.43","currency":"USD"},
        "keywords":[{"id":36126077,"adGroupId":36061494,"text":"best coffee","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.392","deleted":false},
        {"id":36126078,"adGroupId":36061494,"text":"cafe","status":"ACTIVE","matchType":"BROAD","bidAmount":{"amount":"0.05","currency":"USD"},
        "modificationTime":"2017-09-27T10:52:49.893","deleted":false},
        {"id":36126079,"adGroupId":36061494,"text":"coffee","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.05","currency":"USD"},"modificationTime":"2017-09-27T10:52:40.297","deleted":false},
        {"id":36126080,"adGroupId":36061494,"text":"countdown","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.409","deleted":false},
        {"id":36127301,"adGroupId":36061494,"text":"food delivery","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.413","deleted":false},
        {"id":36127302,"adGroupId":36061494,"text":"text free","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.418","deleted":false},
        {"id":36127303,"adGroupId":36061494,"text":"grindr","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.423","deleted":false},
        {"id":36127304,"adGroupId":36061494,"text":"kawa","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.427","deleted":false},
        {"id":36127305,"adGroupId":36061494,"text":"kawa coffee","status":"ACTIVE","matchType":"BROAD",
        "bidAmount":{"amount":"0.01","currency":"USD"},"modificationTime":"2017-09-23T08:06:10.431","deleted":false}],
        "negativeKeywords":[],"targetingDimensions":{"age":null,"gender":null,"country":null,"adminArea":null,"locality":null,
        "deviceClass":{"included":["IPHONE"],"excluded":null},"daypart":null,
        "appDownloaders":{"included":[],"excluded":["1025397186"]}},"orgId":379480,"modificationTime":"2017-09-28T11:48:28.666",
        "status":"ENABLED","servingStatus":"RUNNING","servingStateReasons":null,"displayStatus":"RUNNING","deleted":false}],
        "budgetOrders":[],"displayStatus":"RUNNING",
        "startTime":"2017-09-22T16:00:00.000","endTime":null,"status":"ENABLED","servingStatus":"RUNNING","additionalDetail":null,
        "servingStateReasons":null,"storefront":"US","modificationTime":"2017-11-05T04:20:16.958","deleted":false}
      ]
    }
  }

  componentWillMount() {
    this.setState({ message: '' });
  }

  componentDidMount(){

    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    // axios.get(`${API_URL}/searchads/campaigns/find`, { headers } )
    // .then((response)=>{
    //   // const raw_data = response.data;
    //   console.log(response.data);
      
    //   const campaignList = response.data;
    //   this.setState(
    //     { campaignList }
    //   )
    // })
  }

  createCampaign(){
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    console.log(headers)
    
    axios.post(`${API_URL}/searchads/campaigns/create/`, {}, { headers } )
    
    .then(response => this.setState({ message: 'asdfsdf'}))
    .catch(error => this.setState({ message: error.message }));
  }

  ping() {
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    axios.get(`${API_URL}/public`, { headers })
      .then(response => this.setState({ message: response.data.message }))
      .catch(error => this.setState({ message: error.message }));
  }


  HiItems(items) {
    console.log(items)
  }

  

  
  securedPing() {
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    axios.get(`${API_URL}/searchads`, { headers })
      .then(response => this.setState({ message: JSON.parse(response.data.message) }))
      .catch(error => this.setState({ message: error.message }));
  }

  getItemsAsync(searchValue, cb) {

    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    axios.get(`${API_URL}/searchads/search/apps`, { params: { searchValue: searchValue}, headers })
      .then(response => {
        console.log( response.data)
        if(response.data != undefined){
          let itemData = response.data;
          console.log(itemData );
          let items = itemData.map( (res, i) => { return { id: i, value: res.appName + ' ---- ' + res.developerName } })
          console.log( ' items ' , items );
          
          this.setState({ repos: items })
          cb(searchValue)
        }
      // this.setState({ message: JSON.parse(response.data.message) })
      })
      .catch(error => {
        console.log( error.message)
        this.setState({ message: error.message })
      });  

  }

  handleChange(e, { newValue }) {
    this.props.dispatch(setKeyword(newValue));
  }

  handleSuggest({ value }) {
    this.props.dispatch(requestSuggest(value));
  }

  handleClear() {
    this.props.dispatch(clearSuggests());
  }

  renderSuggestion = ( (suggestion, { query })=> {
    console.log( suggestion);
    return (

      <span>{suggestion.appName}</span>
    );
  });

  render() {
    const { message } = this.state;
    const { currentApp } = this.props;
    console.log('search' , this.props.search.toJS())
    const { suggests, keyword }  = this.props.search.toJS();
    const props = {
      value: keyword,
      onChange: this.handleChange.bind(this)
    };

    if ( currentApp ) {
      return  <Redirect to={`/addCampaign/appId/${currentApp.adamId}` }/>;
      
    } else {
      return  <Redirect to={`/` }/>;
      
    }
    const { isAuthenticated } = this.props.auth;

    return (
      <CampaignWrapper>
      <div className="container">
        <h1>Make a Call to the Server { currentApp}</h1>
        {
          !isAuthenticated() &&
            <p>Log in to call a private (secured) server endpoint.</p>
        }
        <Button bsStyle="primary" onClick={this.ping.bind(this)}>Ping</Button>
        <Button bsStyle="primary" onClick={this.createCampaign.bind(this)}>Create Campaign</Button>

        
        {' '}
        {
          isAuthenticated() && (
              <Button bsStyle="primary" onClick={this.securedPing.bind(this)}>
                Call Private
              </Button>
            )
        }

        {/* <div className="row about-body">
            
              { 
                this.state.campaignList.map( ( item, i) =>
                <div className="col-xs-12">
                  <h3>{item.name}</h3>
                  <h4>{item.position}</h4>
                </div>
              )}
                  
            </div> */}
        <h2>{ message}</h2>

        <div>
        <Suggest
          suggestions={suggests}
          onSuggestionsFetchRequested={this.handleSuggest.bind(this)}
          onSuggestionsClearRequested={this.handleClear.bind(this)}
          renderSuggestion={this.renderSuggestion.bind(this)}
          getSuggestionValue={s => s.appName}
          inputProps={props}
          onSuggestionSelected={ (event, data) => {
            console.log( data);
            this.props.history.push(`/addCampaign/appId/${data.suggestion.adamId}`)            
          }}
        />
          {/* <Search items={this.state.repos}
                  multiple={false}
                  getItemsAsync={this.getItemsAsync.bind(this)}
                  onItemsChanged={this.HiItems.bind(this)} /> */}
        </div>
      </div>
      </CampaignWrapper>
    );
  }
}

function mapStateToProps(state) {
  return { 
    search: state.get('search') ,
    currentApp: state.getIn( ['App', 'currentApp']),
  }
}



export default  connect(mapStateToProps)(AddCampaign);



// WEBPACK FOOTER //
// ./src/containers/AddCampaign/index.js